import React, { useState, useEffect } from "react";
import { Menu, Dropdown, Avatar } from "antd";
import { connect } from "react-redux";
import { CaretDownFilled } from "@ant-design/icons";
import IcoMoonIcon from "components/util-components/IcoMoonIcon";
import { signOut } from "redux/actions/Auth";
import { APP_PREFIX_PATH } from "configs/AppConfig";
import axios from "axios";
import { LogoutOutlined, InfoCircleOutlined,CreditCardOutlined } from "@ant-design/icons";
import { Link, useLocation } from "react-router-dom";
const menuItem = [
	{
		title: "Update my Profile",
		icon: "Edit1",
		path: "SettingsAccount",
	},
];

export const NavProfile = ({ signOut }) => {
  const location = useLocation();
  const pathParts = location.pathname.split('/');
  const paymentValue = pathParts[1];
  
	const [userInfo, setuserInfo] = useState({});
	const user = localStorage.getItem("USER");
	const appUserId = localStorage.getItem("APP_USER_ID");
	const appUserRoleId = localStorage.getItem("USER_ROLE_ID");
	const loginMode = localStorage.getItem("LOGIN_RENDER_MODE");
  const paymentData = JSON.parse(localStorage.getItem("PAYMENT_DATA"));

  useEffect(() => {
    if (appUserId !== null) {
      axios
        .get(`/AppUser/${appUserId}`, {
          params: {},
        })
        .then((res) => {
          setuserInfo(res.data);
        });
    }
  }, [appUserId]);

  const navigatePaymentPage = () => {
  };

	const profileImg = "/img/avatars/thumb-1.svg";
	const profileMenu = (
		<div className="nav-profile nav-dropdown">
			<div className="nav-profile-header">
				<div className="d-flex">
					<Avatar size={45} src={profileImg} />
					<div className="pl-3">
						<h4 className="mb-0 m font-size-md">
							{appUserId !== null
								? userInfo?.firstName + " " + userInfo?.lastName
								: user}
						</h4>
						{/* <span className="text-muted font-size-sm">
              Last logged today at 16.21
            </span> */}
          </div>
        </div>
      </div>
      <div className="nav-profile-body">
        <Menu>
          {menuItem.map((el, i) => {
            return (
              <Menu.Item disabled key={1}>
                <Link
                  to={`${APP_PREFIX_PATH}/${el.path}`}
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <IcoMoonIcon icon={el.icon} size={15} className="mr-2" />
                  <span className="font-weight-normal">{el.title}</span>
                </Link>
              </Menu.Item>
            );
          })}
          {appUserRoleId == "11111111-1111-1111-1111-111111111111" && loginMode =="systemLog" && paymentData?.isEnablePaymentMode == true?(
            <Menu.Item
              key={2}
              onClick={(e) => {
                navigatePaymentPage();
              }}
              >
              <span>
                <CreditCardOutlined className="mr-3" />
                <a href="/zodiac/account">Account </a>
              </span>
            </Menu.Item>
          ):null}

           {paymentValue !=="payment"?(<Menu.Item>
              <InfoCircleOutlined className="mr-3" />
              <a href="/zodiac/about">About</a>
          </Menu.Item>):null}
          <Menu.Item
            key={3}
            onClick={(e) => {
              signOut();
              localStorage.clear();
            }}
          >
            <span>
              <LogoutOutlined className="mr-3" />
              {/* <span className="font-weight-normal">Sign Out</span> */}
              <a href="/auth/login">LogOut </a>
            </span>
          </Menu.Item>
        </Menu>
      </div>
    </div>
  );
  return (
    <Dropdown placement="bottomRight" overlay={profileMenu} trigger={["click"]}>
      <Menu className="d-flex align-item-center" mode="horizontal">
        <Menu.Item>
          <Avatar src={profileImg} />
          <CaretDownFilled />
        </Menu.Item>
      </Menu>
    </Dropdown>
  );
};

export default connect(null, { signOut })(NavProfile);
